<template>
    <div class="gsheet_mapping">
        <div class="google_sheets">
            <div class="link_item_btn_wrpr">
	            <label class="label">Mappings</label>
	            <div class="flex"></div>
              <v-button border @click="autoMap" class="btn brdr_btn link_item_btn">
                  <inline-svg :src="require('@/assets/img/auto_match_fields_icon.svg')"/>
                  Auto-match fields
              </v-button>
            </div>
            <div class="field_mapping_wrpr">
                <div class="no_items_text" v-if="localMappings.length<1" @click="addRow">
                    Get started by adding new mappings
                    <div class="add_condition_btn">
                        <inline-svg :src="require('@/assets/img/add_plus_icon.svg')"/> Add field mapping
                    </div>
                </div>
                <div v-if="localMappings.length>0" class="columns-header layout-row flex flex-center">
                    <span>Funnelish</span>
                    <span class="field_mapping_arrow"></span>
                    <span style="margin-left: -40px;">Google Sheet Column</span>
                </div>

	            <mapping-row v-for="(row, index) in localMappings" :row="row" :key="index" :originalSources="originalSources"
	                         :mappings="localMappings" :sources="sources" :targets="targets" :originalTargets="originalTargets"
	                         @removeRow="removeRow" @updateMapping="updateAllMappings" :loading-sources="loadingSources" />

            </div>
            <a @click="addRow" v-if="localMappings.length>0" class="add_condition_btn">
	            <inline-svg :src="require('@/assets/img/add_plus_icon.svg')"/> Add field mapping
            </a>
        </div>
    </div>
</template>


<script>
import MappingRow from "@/components/integrations/mapping-row";
import VButton from "@/components/base/v-button";
import API from '@/api';

export default {
    name: "GoogleSheetMapping",
    components: {
	    VButton,
	    MappingRow
    },
    props: ['fields', 'prefill', 'mappings'],
	mixins:[API],
    data() {
        return {
	        loadingSources: true,
          metadataFields: [
	          // {id:"meta.utm_source", text:"UTM Source"},
          ],
          originalTargets: [
              { id: "A", text: "" },
              { id: "B", text: "" },
              { id: "C", text: "" },
              { id: "D", text: "" },
              { id: "E", text: "" },
              { id: "F", text: "" },
              { id: "G", text: "" },
              { id: "H", text: "" },
              { id: "I", text: "" },
              { id: "J", text: "" },
              { id: "K", text: "" },
              { id: "L", text: "" },
              { id: "M", text: "" },
              { id: "N", text: "" },
              { id: "O", text: "" },
              { id: "P", text: "" },
              { id: "Q", text: "" },
              { id: "R", text: "" },
              { id: "S", text: "" },
              { id: "T", text: "" },
              { id: "U", text: "" },
              { id: "V", text: "" },
              { id: "W", text: "" },
              { id: "X", text: "" },
              { id: "Y", text: "" },
              { id: "Z", text: "" },
              { id: "AA", text: "" },
              { id: "AB", text: "" },
              { id: "AC", text: "" },
              { id: "AD", text: "" },
              { id: "AE", text: "" },
              { id: "AF", text: "" },
              { id: "AG", text: "" },
              { id: "AH", text: "" },
              { id: "AI", text: "" },
              { id: "AJ", text: "" },
              { id: "AK", text: "" },
              { id: "AL", text: "" },
              { id: "AM", text: "" },
              { id: "AN", text: "" },
              { id: "AO", text: "" },
              { id: "AP", text: "" },
              { id: "AQ", text: "" },
              { id: "AR", text: "" },
              { id: "AS", text: "" },
              { id: "AT", text: "" },
              { id: "AU", text: "" },
              { id: "AV", text: "" },
              { id: "AW", text: "" },
              { id: "AX", text: "" },
              { id: "AY", text: "" },
              { id: "AZ", text: "" }
          ],

	        targets: [],
	        sources: [],
	        localMappings: [],
        }
    },
    computed: {
	    originalSources() {
				let fields = [];
				this.metadataFields.forEach(x=> {
					fields.push({id:`meta.${x.key}`,text:x.key})
				})
				return [
					//Customer Details:
					{id: "_custom_group_one", text: "Customer details", group: true, disabled: true},
					{id:"email", text:"Email"},
					{id:"first_name", text:"First name"},
					{id:"last_name", text:"Last name"},
					{id:"full_name", text:"Full name"},
					{id:"paying_email", text:"Paying email"},
					{id:"phone", text:"Phone"},
					{id:"address", text:"Address"},
					{id:"zip", text:"Zip"},
					{id:"state", text:"State"},
					{id:"city", text:"City"},
					{id:"country", text:"Country"},
					{id:"shipping_address", text:"Shipping address"},
					{id:"shipping_zip", text:"Shipping zip"},
					{id:"shipping_state", text:"Shipping state"},
					{id:"shipping_city", text:"Shipping city"},
					{id:"shipping_country", text:"Shipping country"},
					{id:"customer_id", text:"Customer ID"},
					//Order Details:
					{id: "_custom_group_two", text: "Order details", group: true, disabled: true},
					{id:"time", text:"Time", matches: ["date","time"]},
					{id:"order_id", text:"Order ID", matches: ["order id","order number"]},
					{id:"ref", text:"Transaction reference", matches: ["transaction id", "transaction reference", "transaction number"]},
					{id:"test_mode", text:"Test Mode"},
					{id:"product_name", text:"Product name", matches: ["product name","product"]},
					{id:"variant_name", text:"Variant name"},
					{id:"qty", text:"Quantity", matches:["quantity","qty"]},
					{id:"amount", text:"Amount", matches:["amount","price","cost","prix"]},
					{id:"source", text:"Source"},

					{id: "_custom_group_three", text: "UTM tags", group: true, disabled: true},
					{id:"meta.utm_source", text:"UTM Source"},
					{id:"meta.utm_medium", text:"UTM Medium"},
					{id:"meta.utm_campaign", text:"UTM Campaign"},
					{id:"meta.utm_content", text:"UTM Content"},
					{id:"meta.utm_term", text:"UTM Term"},

					{id: "_custom_group_four", text: "Metadata", group: true, disabled: true},
					...fields
				]
			}
    },
    watch: {
      fields(val) {
      	this.attachFieldsToTargets();
        this.resetTargets();
      },
    },
    methods: {
	    removeRow(row) {
	    	let index = this.localMappings.indexOf(row)
		    this.localMappings.splice(index, 1);

	    	this.updateAllMappings();
		    this.$emit('mapping', this.localMappings);
	    },
	    updateAllMappings() {
		    // 1. reset sources/targets to original state.
		    this.resetSources();
		    this.resetTargets();

		    // 2. remove the source/target from suggestions lists
		    this.localMappings.forEach(row => {

			    let srcIndex = this.sources.findIndex(x => x.id === row.src);
			    if (srcIndex >= 0) {
				    this.sources.splice(srcIndex, 1);
			    }
			    let targetIndex = this.targets.findIndex(x => x.id === row.target);
			    if (targetIndex >= 0) {
				    this.targets.splice(targetIndex, 1);
			    }
		    })

		    // 3. propagate event to parent.
		    this.$emit("mapping", this.localMappings);
	    },
	    autoMap() {
		    let self = this;
		    this.localMappings.splice(0, this.localMappings.length);

		    this.originalSources.forEach((item, index)=> {
			    self.fields.fields.forEach((field, fIndex) => {

				    let target = item.matches ?
						    item.matches.indexOf(field.toLowerCase()) :
						    field.toLowerCase().indexOf(item.text.toLowerCase())

				    if(target!== -1) {
					    self.localMappings.push({src: item.id, target: self.originalTargets[fIndex].id })
				    }
			    });
		    });
		    this.updateAllMappings();
	    },
	    addRow() {
		    this.localMappings.push({
			    "src": "",
			    "target": "",
		    });
	    },
	    attachFieldsToTargets() {
		    this.originalTargets.forEach((item, index) => {
			    item.text = "";
		    });

		    if (this.fields.fields) {
			    this.originalTargets.forEach((item, index) => {
				    if (index < this.fields.fields.length) {
					    item.text = this.fields.fields[index];
				    }
			    });
		    }
	    },
	    resetTargets() {
		    this.targets.splice(0, this.targets.length);
		    this.originalTargets.forEach((item, index) => {
			    this.targets.push(item);
		    });
	    },
	    resetSources() {
		    this.sources.splice(0, this.sources.length);

		    this.originalSources.forEach((item, index) => {
			    this.sources.push(item);
		    });
	    },
	    async loadMeta() {
				try {
					this.metadataFields = [];
					this.loadingSources = true;
					let meta = await this.api.integrations.method('google_sheets', 'get-meta-fields', {});
					if (meta && meta.success) {
						this.metadataFields = meta.result || [];
						this.updateAllMappings();
					} else throw meta
				} catch (e) {
					this.$error(e)
				} finally {
					this.loadingSources = false;
				}
	    }
    },
    created() {
    	if (this.mappings) {
    		this.localMappings = JSON.parse(JSON.stringify(this.mappings))
	    } else {
    		this.localMappings = []
	    }

    	this.attachFieldsToTargets();
	    this.resetTargets();
	    this.resetSources();
	    this.updateAllMappings();
    },
	mounted() {
			this.loadMeta()
	}

}
</script>

<style lang="scss" scoped>
.label {
	color: $blue;
	font-weight: 500;
}
</style>
<style lang="scss">
.vs__selected .select-option .option-column{
	max-width: 180px;
}
    .gsheet_mapping {
        .mappings-headline {
            font-weight: 500;
            color: #4268df;
        }

        .columns-header {
	        margin: 8px 0;
	        padding: 0 10px;

            .field_mapping_arrow {
                width: 41px;
            }

            >span:not(.field_mapping_arrow) {
                width: 100%;
                flex: 1;
                //max-width: 288px;
                font-weight: 500;
                color: silver;
            }
        }

        .vs__dropdown-toggle {
            height: 30px;
            background: white;
        }
    }

    .vs__dropdown-option--disabled {
        &.vs__dropdown-option--selected {
            font-weight: 700;
        }
        .group {
            font-weight: 700;
        }
    }

    .select-option {
        margin: 0;
        position: relative;

        .option-column {
            color: silver;
            font-weight: 400;
            margin-left: 10px;
        }

        &.active {
            .option-column {
                color: white !important;
            }
        }

    }
</style>
